export class Application {
  public id: number;
  public name: string;
  public descr: string;
  public order_index: number;
}

export class ApplicationInfoModel {
  public artifactId?: string;
  public version?: string;
}



// WEBPACK FOOTER //
// ./src/app/models/application.model.ts